export function formData(props) {
  let fData = new FormData();

  Object.keys(props).map(function (key, index) {
    let value = props[key];

    fData.append(key, value);


  });

  return fData
}



// WEBPACK FOOTER //
// ./src/components/utils/formData.js